var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroDivider2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 375,
    height: 36,
    viewBox: "0 0 375 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375 30.9999V18.9999C322.483 -1.65527 267.373 1.31863 211.689 8.73641C212.518 8.626 213.346 8.51659 214.175 8.40822C269.013 7.61247 323.265 10.6522 375 30.9999ZM189.071 11.9422C183.74 12.7321 178.406 13.539 173.071 14.346C165.779 15.4491 158.485 16.5524 151.193 17.6133C158.485 16.5524 165.779 15.4491 173.071 14.346L173.071 14.346C178.406 13.539 183.74 12.7321 189.071 11.9422Z",
    fill: "#A8DFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.258 9.70906C110.852 11.6444 54.4066 13.581 0 1V18.9999C56.2758 32.0132 114.733 23.1706 173.071 14.346L173.071 14.346C186.789 12.2709 200.5 10.1969 214.174 8.40831C198.568 8.63477 182.914 9.17186 167.258 9.70906Z",
    fill: "#C6D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.5001C222 68 259 -32 375 12",
    stroke: "#54A178"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroDivider2);
export default __webpack_public_path__ + "static/media/intro-divider-2.2e6b5d01c103bb95f05a4d4797d15a5b.svg";
export { ForwardRef as ReactComponent };